exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=checkbox][data-v-50b0dec6] {\n  -webkit-transform: scale(1.5);\n          transform: scale(1.5);\n  margin-right: 15px;\n  cursor: pointer;\n}\nlabel[data-v-50b0dec6] {\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50b0dec6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/input/InputCheckbox.vue
// module id = pNme
// module chunks = 53